import plugins from './plugins';

export default function destroyPlugins() {
  return new Promise((resolve) => {
    plugins.forEach(plugin => plugin && plugin.destroy && plugin.destroy());
    plugins.length = 0;
    resolve(true);
  });
}



// WEBPACK FOOTER //
// ./scripts/plugins/destroyPlugins.js